import { loop } from 'sdi/app';
import { DIV } from 'sdi/components/elements';
import header from 'qa/src/components/header';
import footer from 'qa/src/components/footer';
import about from 'qa/src/components/about';

import { loadRoute } from './events/route';
import index from './components/index';
import main from './components/main';
import modal from './components/modal';
import {
    // loadCurrentOsmUser,
    // loadEvaluationList,
    // loadGlobalNoteList,
    // loadIssueList,
    // loadIssueNoteList,
    loadIssueTypes,
    loadTheme,
} from './events/qa';
import { addIssueLayer } from './events/map';
import { getLayout } from './queries/app';

const wrappedMain = (
    name: string,
    ...elements: React.DOMElement<{}, Element>[]
) =>
    DIV(
        { className: 'project' },
        modal(),
        header('qa'),
        DIV({ className: `main ${name}` }, ...elements),
        footer()
    );

const renderIndex = () => {
    switch (getLayout()) {
        case 'about':
            return wrappedMain('about', about());
        case 'index':
            return wrappedMain('index', index());
        default:
            return wrappedMain('main', main());
    }
};

const render = () => renderIndex();

const effects = (initialRoute: string[]) => () => {
    loadTheme()
        //loadIssueList()
        .then(() => loadRoute(initialRoute))
        .then(loadIssueTypes)
        // .then(loadEvaluationList)
        // .then(loadIssueNoteList)
        // .then(loadGlobalNoteList)
        .then(addIssueLayer);
    // .then(loadCurrentOsmUser);
};

export const app = (initialRoute: string[]) =>
    loop('qa', render, effects(initialRoute));
